import {SearchQueryField} from '../types/models';

export const QUERY_FIELDS = {
    'residents': [
        new SearchQueryField('Unit', 'suite.suiteNumber', true),
        new SearchQueryField('Full Name', 'user.fullName', true),
        new SearchQueryField('Building Name', 'building.name'),
        new SearchQueryField('Building Address', 'building.address'),
        new SearchQueryField('Email', 'user.email'),
        new SearchQueryField('Phone', 'user.primaryPhone'),
        new SearchQueryField('Note', 'user.note'),
        // new SearchQueryField('Username', 'user.username'),
        // new SearchQueryField('Role', 'role'),
    ],
    'units': [
        new SearchQueryField('Unit', 'suiteNumber', true),
        new SearchQueryField('Building', 'building.name'),
        new SearchQueryField('Buzz', 'buzz'),
        new SearchQueryField('Prop. Share', 'proportionateShare'),
        new SearchQueryField('Key Fob.', 'keyFob'),
        new SearchQueryField('Key Code', 'keyCode'),
        new SearchQueryField('Sub Name', 'subName'),
        new SearchQueryField('Note', 'note')
    ],
    'parking-spots': [
        new SearchQueryField('Unit', 'suite.suiteNumber', true),
        new SearchQueryField('Building', 'building.name'),
        new SearchQueryField('Parking Number', 'parkingNumber'),
        new SearchQueryField('Note', 'note'),
        new SearchQueryField('Rented To', 'rentedTo')
    ],
    'lockers': [
        new SearchQueryField('Unit', 'suite.suiteNumber', true),
        new SearchQueryField('Building', 'building.name'),
        new SearchQueryField('Locker Number', 'lockerKeyCode'),
        new SearchQueryField('Note', 'note'),
        new SearchQueryField('Rented To', 'rentedTo')
    ],
    'vehicles': [
        new SearchQueryField('Unit', 'suite.suiteNumber', true),
        new SearchQueryField('Building', 'building.name'),
        new SearchQueryField('License Plate', 'licensePlateForSearch|licensePlate', true),
        new SearchQueryField('Make', 'brand'),
        new SearchQueryField('Model', 'model'),
        new SearchQueryField('Year', 'year'),
        new SearchQueryField('Color', 'color'),
        new SearchQueryField('Note', 'note')
    ],
    'pets': [
        new SearchQueryField('Unit', 'suite.suiteNumber', true),
        new SearchQueryField('Building', 'building.name'),
        new SearchQueryField('Pet Type', 'petType.name'),
        new SearchQueryField('Name', 'name'),
        new SearchQueryField('Note', 'note'),
    ],
    'bike-racks': [
        new SearchQueryField('Unit', 'suite.suiteNumber', true),
        new SearchQueryField('Building', 'building.name'),
        new SearchQueryField('Rack Number', 'rackNumber'),
        new SearchQueryField('Note', 'note'),
        new SearchQueryField('Rented To', 'rentedTo')
    ],
    'vendors': [
        new SearchQueryField('Name', 'name', true),
        new SearchQueryField('Phone', 'phones.number', true),
        new SearchQueryField('City', 'addresses.city', true),
        new SearchQueryField('Category', 'categories.name', true),
        new SearchQueryField('Lists', 'corporations.name|companies.vendorListName', true),
    ],
    'allParcels': [
        new SearchQueryField('Unit', 'suite.suiteNumber', true),
        new SearchQueryField('Full Name', 'resident.fullName'),
        new SearchQueryField('Building', 'building.name'),
        new SearchQueryField('Barcode', 'barCode', true),
        new SearchQueryField('Courier', 'parcelPostServiceName'),
        new SearchQueryField('Parcel Number', 'parcelNumber'),
        new SearchQueryField('Received By', 'receivedBy.fullName'),
        new SearchQueryField('Picked Up By', 'pickedUpBy.fullName'),
        new SearchQueryField('Delivered By', 'deliveredBy.fullName'),
        // 'numberPieces',
        // 'status',
        // 'parcelNumber'
    ],
    'allIncidentReports': [
        new SearchQueryField('ID#', 'incidentReportNumber'),
        new SearchQueryField('Incident', 'incident'),
        new SearchQueryField('Building', 'building.name'),
        new SearchQueryField('Type', 'incidentReportType.name|incidentReportTypeOther'),
        new SearchQueryField('Unit', 'suite.suiteNumber'),
        new SearchQueryField('Reported Area', 'reportedArea'),
        new SearchQueryField('Reported By', 'reportedBy'),
        new SearchQueryField('Created By', 'createdBy.fullName'),
        // 'incidentReportTypeOther',
    ],
    'allKeyLogs': [
        new SearchQueryField('Key Tag', 'keyTag'),
        new SearchQueryField('Unit/Room', 'suite.suiteNumber'),
        new SearchQueryField('Purpose', 'purpose'),
        new SearchQueryField('Building', 'building.name'),
        new SearchQueryField('Full Name', 'activities.user.fullName'),
        new SearchQueryField('Status', 'status'),
        new SearchQueryField('Notes', 'notes'),
    ],
    'allClassifieds': [],
    'allPassOnLogs': [
        new SearchQueryField('ID#', 'passOnLogNumber'),
        new SearchQueryField('Subject', 'subject'),
        new SearchQueryField('Announcement', 'announcement'),
        new SearchQueryField('Created By', 'createdBy.fullName'),
    ],
    'allDailyReports': [
        new SearchQueryField('ID#', 'dailyReportNumber'),
        new SearchQueryField('Building', 'building.name'),
        new SearchQueryField('Relieved', 'relieved'),
        new SearchQueryField('Relieved By', 'relievedBy'),
    ],
    'email': [
        new SearchQueryField('Subject', 'subject'),
        new SearchQueryField('Message Body', 'message'),
        new SearchQueryField('Building Name', 'buildingName'),
        new SearchQueryField('Building Address', 'buildingAddress'),
        new SearchQueryField('Status', 'status'),
    ],
    'document': [
        new SearchQueryField('Name', 'name', true),
        new SearchQueryField('Building', 'buildings.name'),
    ],
    'allServiceRequests': [
        new SearchQueryField('ID', 'serviceRequestNumber'),
        new SearchQueryField('Building', 'building.name'),
        new SearchQueryField('Unit', 'suite.suiteNumber', true),
        new SearchQueryField('Full Name', 'resident.fullName', ),
        new SearchQueryField('Type', 'serviceRequestType.name', ),
        new SearchQueryField('Created By', 'createdBy.fullName', ),
        // new SearchQueryField('Requests Number', 'serviceRequestNumber', true),
        // 'serviceRequestWorkerContract.name',
        // 'serviceRequestTypeOther',
        // 'serviceRequestWorkerContractOther',
        // 'createdBy.fullName',
    ],
    'rules': [],
    'lots': [],
    'allAmenities' : [
        new SearchQueryField('ID#', 'bookingNumber'),
        new SearchQueryField('Amenity', 'amenity.name'),
        new SearchQueryField('Building', 'building.name'),
        new SearchQueryField('Unit', 'suite.suiteNumber', true),
        new SearchQueryField('Resident', 'resident.fullName'),
    ],
    'allParkingPasses' : [
        new SearchQueryField('ID#', 'bookingNumber'),
        new SearchQueryField('Unit', 'suite.suiteNumber', true),
        new SearchQueryField('Parking Lot', 'parkingLot.name'),
        new SearchQueryField('License Plate', 'visitor.licensePlate', true),
        new SearchQueryField('Visitor', 'visitor.fullName'),
        new SearchQueryField('Resident', 'resident.fullName'),
    ],
    'allSettingsParcels': [],
    'allReports' : [],
    'allTemplates' : [], // todo: https://gitlab.mcc-dev.org/maxtvmedia/mcc_report_builder/tree/master/src/Repository ?
    'companies': [
        new SearchQueryField('Name', 'name'),
        new SearchQueryField('Email', 'email'),
        new SearchQueryField('Address', 'address'),
        new SearchQueryField('Phone #', 'phone'),
    ],
    'property': [
        new SearchQueryField('Property Mgmt', 'companyName'),
        new SearchQueryField('Property Name', 'name'),
        new SearchQueryField('Corporation', 'corporationNumber.name'),
        new SearchQueryField('Address', 'address'),
        new SearchQueryField('Created By', 'createdBy.fullName'),
        new SearchQueryField('Property Number', 'propertyNumber'),
    ],
    'user': [
        new SearchQueryField('Full Name', 'fullName'),
        new SearchQueryField('Company Name', 'company.name'),
        new SearchQueryField('Email', 'email'),
    ],
    'themes': [
        new SearchQueryField('Theme Name', 'name'),
    ],
    'allSettingsAmenities': [
        new SearchQueryField('ID#', 'internalId'),
        new SearchQueryField('Amenity', 'name'),
        new SearchQueryField('Building', 'buildingAmenity.buildingName'),
    ],
};



// WEBPACK FOOTER //
// /app/src/app/services/url.service.data.ts